module.exports = __webpack_public_path__ + "static/media/Dakar-User-Profile.81ca67aa.png";